import Default from "./ReadonlyAccount";
export * from "./ReadonlyAccount";

export default Default;
